import { useContext } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../context/Provider";
import { breadcrumArray } from "./commonInterface";

const BreadCrumb = (props: breadcrumArray) => {
  const { authState, language_data } = useContext(GlobalContext);

  const items = props?.pathNameDeclare || [];
  const currentPageTitle = items[items.length - 1]?.name || '';

  return (
    <div className="w-full bg-white border-b border-slate-100 px-4 sm:px-6 lg:px-8 py-3.5">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
        <div>
          {/* Main Page Title */}
          <h2 className="text-xl sm:text-2xl font-bold text-slate-800 tracking-tight m-0">
            {currentPageTitle}
          </h2>

          {/* Breadcrumb Navigation Trail */}
          <nav aria-label="breadcrumb" className="mt-1">
            <ol className="flex items-center flex-wrap gap-1.5 text-xs font-semibold m-0 p-0 list-none">
              {items.map((res, index: number) => {
                const isLast = index === items.length - 1;
                const isClickable = !isLast && res?.url && res?.url !== '' && res?.active !== 'not-allowed';

                return (
                  <li key={index} className="flex items-center gap-1.5">
                    {index > 0 && <span className="text-slate-400 font-normal">/</span>}
                    {isClickable ? (
                      <Link
                        to={`${res?.url}`}
                        className="text-[#1AA7DE] hover:text-[#1596c9] hover:underline transition-colors"
                      >
                        {res?.name}
                      </Link>
                    ) : (
                      <span className={isLast ? "text-slate-600 font-semibold" : "text-slate-500 font-medium"}>
                        {res?.name}
                      </span>
                    )}
                  </li>
                );
              })}
            </ol>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default BreadCrumb;